import { loadJs, loadCss } from "~/helpers/file";

export const useSwiper = async () => {
  const loaded = ref();

  if (loaded.value) return loaded;
  await loadJs("/static/libs/swiper-bundle.min.js", "swiperJS");
  await loadCss("/static/libs/swiper-bundle.min.css", "swiperCSS");
  loaded.value = true;

  return loaded;
};
